import Timeline from "./timeline";
import TimelinePagination from "./timeline-pagination";
import {TimelineTabsSlider} from "./timeline-tabs-slider";

const SCHEDULE_LIST_CONTAINER_SELECTOR = '.schedule-container';

export class ScheduleList {
    protected $container = $(SCHEDULE_LIST_CONTAINER_SELECTOR);

    protected isLoading = false;

    constructor() {
        if (this.$container.length) {
            this.bindEvents();
        }
    }

    bindEvents(): void {
        this.$container.on('click', '.btn-timeline-day', this.handleTimelineDayClick.bind(this));
    }

    handleTimelineDayClick(e: Event): void {
        e.preventDefault();

        if (this.isLoading) {
            return;
        }

        this.isLoading = true;

        const currentTarget = e.currentTarget as HTMLLinkElement;

        if (typeof currentTarget.href !== 'string') {
            return;
        }

        this.loadTimeline(currentTarget.href)
            .then()
            .catch(() => alert('Ошибка!'))
            .finally(() => this.isLoading = false);
    }

    loadTimeline(targetHref: string): Promise<void> {
        return this.fetchPage(targetHref).then(page => this.setResultByPage(page));
    }

    protected setResultByPage(pageHtml): void {
        const targetHtml = $(pageHtml).find(SCHEDULE_LIST_CONTAINER_SELECTOR).html();
        this.$container.html(targetHtml);
        new Timeline();
        new TimelineTabsSlider();
    }

    protected fetchPage(url: string): Promise<string> {
        return fetch(url).then(res => res.text());
    }
}
